import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "nav justify-content-between align-items-center border px-3 border-2 sticky-top bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "navbar-item justify-content-start"
}
const _hoisted_3 = {
  key: 1,
  class: "navbar-item justify-content-center"
}
const _hoisted_4 = {
  key: 2,
  class: "navbar-item justify-content-end"
}

import NavbarCenterItem from './NavbarCenterItem.vue'
import NavbarLeftItem from './NavbarLeftItem.vue'
import NavbarRightItem from './NavbarRightItem.vue'
import { useSessionStore } from '@/store/useSessionStore';
import { storeToRefs } from 'pinia';

export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    title: {},
    hideRight: { type: Boolean },
    hideCenter: { type: Boolean },
    hideLeft: { type: Boolean }
  },
  setup(__props: any) {

const sessionStore = useSessionStore()
const { session } = storeToRefs(sessionStore)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (!_ctx.hideLeft)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createVNode(NavbarLeftItem)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideCenter)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createVNode(NavbarCenterItem, { title: _ctx.title }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideRight)
      ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
          _createVNode(NavbarRightItem, { session: _unref(session) }, null, 8, ["session"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})